import EfCheckInActivities from '@elem/ui/ef-check-in-activities';
import { Fragment } from 'react';

export default function Content({ id, data, initIndex = 0, isEditStatus = false }: any) {
    const { pageUrl, loginType } = data;

    console.log({ data });
    return (
        <Fragment>
            {pageUrl && (
                <div id={id} className="GtmModuleData-section" data-section-id={'Member-CheckIn'} data-section-title={'Member-CheckIn'}>
                    <EfCheckInActivities pageUrl={pageUrl} loginType={loginType} />
                </div>
            )}
        </Fragment>
    );
}
